"use client";

import React, {useEffect, useRef, useState} from "react";
import {Container} from "@/shared/components/shared";
import {Button} from "@/shared/components/ui/button";
import UniversalBookingModal from "@/shared/components/ui/universal-booking-modal";

const CATALOG_MENU = [
    {
        label: "Плановое обслуживание",
        links: [
            {label: "Замена тех. жидкостей", href: "#oils"},
            {label: "Замена масла в двигателе", href: "#brakes"},
            {label: "Замена свечей зажигания", href: "#2"},
            {label: "Замена фильтров", href: "#3"},
            {label: "Замена топливного фильтра", href: "#4"},
            {label: "Замена колодок", href: "#5"},
        ],
    },
    {
        label: "Диагностика",
        links: [
            {label: "Комплексная диагностика по 79 параметрам", href: "#fix"},
        ],
    },
    {
        label: "Подготовка к сезону",
        links: [
            {label: "Переобувка колес (смена шин)", href: "#tires"},
            {label: "Перекидка колес (шины на дисках)", href: "#tiresChange"},
            {label: "Сезонное хранение шин", href: "#tiresStorage"},
        ],
    },
    {
        label: "АвтоРемонт",
        links: [
            {label: "Диагностика ходовой части", href: "#diagnostic"},
            {label: "Ремонт ходовой части", href: "#diagnostic1"},
            {label: "Ремонт двигателя", href: "#diagnostic2"},
            {label: "Развал-схождение", href: "#diagnostic3"},
        ],
    },
    {
        label: "Охрана автомобиля",
        links: [
            {label: "Ремонт охранного оборудования", href: "#wheels"},
            {label: "Консультация по охранному оборудованию", href: "#wheels1"},
            {label: "Установка охранного оборудования", href: "#wheels2"},
        ],
    },
    {
        label: "Установка доп. оборудования",
        links: [
            {label: "Установка видеорегистратора", href: "#parts"},
            {label: "Установка сонар (датчика парковки)", href: "#parts3"},
            {label: "Установка магнитолы", href: "#parts4"},
        ],
    },
    // {
    //     label: "Автоэлектрик",
    //     links: [
    //         {label: "Диагностика сканером", href: "#condition"},
    //     ],
    // },
];

const DropDownMenuCustom = ({setIsUniversalBookingOpen}: {setIsUniversalBookingOpen: (value: boolean) => void}) => {
    const [open, setOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!open) return;
        const handleClick = (event: MouseEvent) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target as Node)
            ) {
                setOpen(false);
                setSelectedIndex(null);
            }
        };
        document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, [open]);

    return (
        <div className="relative w-[100%] mt-4" ref={dropdownRef}>
            <button
                type="button"
                onClick={() => {
                    setOpen((v) => !v);
                    if (!open) setSelectedIndex(null);
                }}
                className="w-full px-6 py-4 flex items-center justify-between text-custom-orange leading-none uppercase font-button w-[100%] pl-5 lg:pl-10 pr-5 lg:pr-10 pt-8 lg:pt-6 pb-8 lg:pb-6 border-1 border-custom-brown-light rounded-[5px] bg-custom-brown appearance-none focus:outline-none focus:ring-1 focus:ring-[#79503A] focus:border-transparent"
                style={{
                    color: '#FF6200',
                    minHeight: 58,
                }}
            >
                {selectedIndex === null
                    ? "Выбрать услугу"
                    : CATALOG_MENU[selectedIndex].label}
                <span
                    style={{
                        marginLeft: 8,
                        transition: "transform 0.2s",
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                <svg width="16" height="11" viewBox="0 0 16 11" fill="none" className="text-[#FF6200]">
                    <path d="M0.393555 0.308105L7.57812 9.50098L14.7629 0.308105"
                          stroke="currentColor"/>
                </svg>
            </span>
            </button>

            {open && (
                <div
                    className="absolute left-0 right-0 mt-2 bg-custom-brown rounded-lg shadow-xl z-20 overflow-hidden"
                    style={{animation: "fadeIn .18s"}}
                >
                    {CATALOG_MENU.map((item, idx) => (
                        <div key={item.label}>
                            <button
                                type="button"
                                onClick={() =>
                                    setSelectedIndex(idx === selectedIndex ? null : idx)
                                }
                                className="w-full px-6 py-4 font-bold font-button text-custom-orange flex items-center justify-between hover:bg-custom-brown-light focus:bg-custom-brown transition-colors"
                            >
                                {item.label}
                                <span
                                    style={{
                                        marginLeft: 8,
                                        display: 'flex',
                                        alignItems: 'center',
                                        transition: 'transform 0.18s',
                                        transform:
                                            selectedIndex === idx ? 'rotate(0deg)' : 'rotate(270deg)'
                                    }}
                                >
                      {selectedIndex === idx ? (
                          <svg width={20} height={20} viewBox="0 0 20 20" className="text-[#FF6200]">
                              <path d="M6 8l4 4 4-4" stroke="currentColor" strokeWidth={2} fill="none" strokeLinecap="round"
                                    strokeLinejoin="round" />
                          </svg>
                      ) : (
                          <svg width={20} height={20} viewBox="0 0 20 20" className="text-[#FF6200]">
                              <path d="M8 6l4 4-4 4" stroke="currentColor" strokeWidth={2} fill="none" strokeLinecap="round"
                                    strokeLinejoin="round"/>
                          </svg>
                      )}
                    </span>
                            </button>
                            {selectedIndex === idx && item.links && (
                                <div className="flex flex-col animate-fade-in">
                                    {item.links.map((link) => (
                                        <button
                                            key={link.href}
                                            onClick={() => setIsUniversalBookingOpen(true)}
                                            className="px-6 py-2 hover:bg-custom-brown-light text-custom-orange text-base text-left w-full"
                                            style={{fontWeight: 500, boxShadow: '0 1px 3px 0 rgba(0,0,0,0.03)'}}
                                        >
                                            {link.label}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export const MaximumServiceOnePlace: React.FC = () => {
    const [isUniversalBookingOpen, setIsUniversalBookingOpen] = useState(false);

    return (
        <>
            <section className={'bg-custom-dark-gray'} id={'services'}>
                <Container className={'pt-13 lg:pt-31 pb-12 lg:pb-34'}>
                    <h2 className={'text-white font-bold text-[30px] lg:text-[70px] uppercase lg:text-center leading-[1.2]'}>
                        Максимум услуг<br/> в одном месте
                    </h2>
                    <h3 className={'text-custom-orange text-[24px] lg:text-[45px] uppercase lg:text-center leading-[1.2] mt-15'}>
                        каталог услуг
                    </h3>
                    <div className={'flex flex-col'}>
                        <div className={'w-full lg:max-w-2xl lg:mx-auto'}>
                            <DropDownMenuCustom setIsUniversalBookingOpen={setIsUniversalBookingOpen}/>
                            <div className={'mt-15 flex flex-col lg:grid lg:grid-cols-2 gap-4'}>
                                <Button
                                    onClick={() => setIsUniversalBookingOpen(true)}
                                    className={'pt-[11px] pb-[11px] px-10 text-[16px] lg:text-[16px] text-bold text-white leading-none w-full'}>
                                    записаться
                                </Button>
                                <Button 
                                    variant={"outlineWhite"}
                                    onClick={() => setIsUniversalBookingOpen(true)}
                                    className={'mt-4 lg:mt-0 pt-[11px] pb-[11px] px-10 text-[16px] lg:text-[16px] text-bold text-white leading-none w-full'}>
                                    рассчитать стоимость
                                </Button>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
            <UniversalBookingModal isOpen={isUniversalBookingOpen} onClose={() => setIsUniversalBookingOpen(false)} blockName="Максимум услуг в одном месте"/>
        </>
    );
}